import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import { reportDevicePosition } from "utils";
var DeviceSendServiceDataView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceSendServiceDataView, _super);
    function DeviceSendServiceDataView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.comment = null;
        _this.sending = false;
        _this.runtime = 0;
        _this.services = [];
        _this.checkedServices = [];
        _this.changedServices = [];
        _this.lastRuntime = null;
        _this.sent = false;
        _this.warningMessage = null;
        return _this;
    }
    DeviceSendServiceDataView.prototype.mounted = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.product.isInV10) {
                    this.getLastRuntime();
                }
                else {
                    this.warningMessage = this.$t("deviceSendServiceDataView.limitedFeaturesAvailable");
                }
                return [2 /*return*/];
            });
        });
    };
    DeviceSendServiceDataView.prototype.setServiceValues = function () {
        this.services.push({ name: this.$t("deviceMaintenance.serviceGreasing").toString(), value: "301", checked: false, changed: false });
        this.services.push({ name: this.$t("deviceMaintenance.serviceBladeChange").toString(), value: "302", checked: false, changed: false });
        this.services.push({ name: this.$t("deviceMaintenance.serviceCounterBladeChange").toString(), value: "303", checked: false, changed: false });
        this.services.push({ name: this.$t("deviceMaintenance.serviceChainDriveChange").toString(), value: "304", checked: false, changed: false });
        this.services.push({ name: this.$t("deviceMaintenance.serviceMotorChange").toString(), value: "305", checked: false, changed: false });
    };
    DeviceSendServiceDataView.prototype.sendServiceData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sending = true;
                        reportDevicePosition(this.device.serial, "Service");
                        return [4 /*yield*/, axios.post("devicesensorlog/sendservicedata", {
                                serialNumber: this.device.serial,
                                checkedServices: this.checkedServices,
                                changedServices: this.changedServices,
                                runtime: this.runtime,
                                comment: this.comment
                            })];
                    case 1:
                        results = (_a.sent()).data;
                        if (!(results == "OK")) return [3 /*break*/, 2];
                        this.sent = true;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.$showDialog({ text: this.$t("deviceSendServiceDataView.errorSendingData") })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.sending = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DeviceSendServiceDataView.prototype.getLastRuntime = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, axios.get("devicesensorlog/runtime", { params: { serialNumber: this.device.serial } })];
                    case 1:
                        _a.lastRuntime = (_b.sent()).data;
                        this.runtime = this.lastRuntime.runtime;
                        if (this.runtime > 0)
                            this.lastRuntime.runtimeDateString = "(" + new Date(this.lastRuntime.runtimeDateString).toLocaleDateString().split('T')[0] + ")";
                        this.setServiceValues();
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceSendServiceDataView.prototype, "device", void 0);
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceSendServiceDataView.prototype, "product", void 0);
    DeviceSendServiceDataView = tslib_1.__decorate([
        Component
    ], DeviceSendServiceDataView);
    return DeviceSendServiceDataView;
}(Vue));
export default DeviceSendServiceDataView;
